// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../provider/Context.bs.js";
import * as Atom_Cta from "./Atom_Cta.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Type_Common from "../../type/Type_Common.bs.js";
import * as Type_String from "../../type/Type_String.bs.js";

var identifier = "next-episode";

function Atom_NextEpisodeButton(Props) {
  var nextEpisode = Props.nextEpisode;
  var availabilityOpt = Props.availability;
  var availability = availabilityOpt !== undefined ? availabilityOpt : "NotAvailable";
  var match = Context.I18n.getState(undefined);
  var season = nextEpisode.season;
  var progress = Belt_Option.getWithDefault(Type_Common.Progression.getPct(nextEpisode.progression), 0);
  var style = {
    TAG: /* NextEpisode */14,
    _0: progress
  };
  if (availability !== "Available") {
    return null;
  }
  if (season === undefined) {
    return null;
  }
  var label = Curry._1(match.formaters.nextEpisode, {
        progress: progress,
        season: season,
        episode: nextEpisode.episode,
        totalEpisodes: nextEpisode.totalEpisodes
      });
  return React.createElement(Atom_Cta.Link.make, {
              href: Curry._1(Type_String.Href.toString, nextEpisode.href),
              identifier: identifier,
              label: label,
              style: style
            });
}

var make = Atom_NextEpisodeButton;

export {
  identifier ,
  make ,
}
/* react Not a pure module */
